import { RouteType } from "types/RouteType";
import { yardManagementRoutes } from "@intrasync/yard-management";
import placeFromScheduleRoute from "./PlaceFromSchedule/placeFromSchedule.Route";

/**
 * Routes from `@intrasync/yard-management` — the Yard Management hub, Layout
 * Builder and Yard Operations views, replacing the retired NTXYardMap screen.
 *
 * The package exports a ready `RouteType[]` (0.3.3), so no host-side route
 * wrapper is needed; the cast bridges the package's copy of the shared route
 * type to the host's, the same way estimating and accounting do it.
 */
const yardManagementRoutesList: RouteType[] = [
  ...(yardManagementRoutes as unknown as RouteType[]),
  ...placeFromScheduleRoute,
];

export default yardManagementRoutesList;
